<template>
  <TemplateDetails
    :get-function="loadSeller"
    :data="seller"
    :loading="sellerLoading"
    :error-title="loadErrorTitle"
    :error="loadErrorMessage"
    :error-button="$t('store-sellers.delete.backToList')"
    :error-to="listRoute"
  >
    <PageBack :to="listRoute" />

    <Form
      :title="$t('store-sellers.delete.title')"
      :text="$t('store-sellers.delete.subtitle')"
      :success-msg="$t('store-sellers.delete.success')"
      :button="$t('global.permanently_delete')"
      :action="confirmDelete"
      @success="onDeleted"
    >
      <template v-slot:top>
        <SectionTableInfos :fields="summaryFields" :object="seller" />
      </template>
    </Form>
  </TemplateDetails>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TemplateDetails from '@/components/templates/TemplateDetails';
import Form from '@/components/ui/form/Form';
import PageBack from '@/components/ui/page/PageBack';
import SectionTableInfos from '@/components/sections/SectionTableInfos';
import {
  sellerIdFromRoute,
  storeSellerListRoute,
} from '@/utils/store-seller-routes';

export default {
  name: 'StoreSellerDelete',
  components: { SectionTableInfos, PageBack, Form, TemplateDetails },
  data() {
    return {
      summaryFields: [
        { key: 'firstname' },
        { key: 'lastname' },
        { key: 'email' },
      ],
    };
  },
  computed: {
    ...mapState(['seller', 'sellerLoading', 'sellerLoadError']),
    loadErrorTitle() {
      if (this.sellerLoadError === 403) {
        return this.$t('store-sellers.delete.forbiddenTitle');
      }
      if (this.sellerLoadError === 404) {
        return this.$t('store-sellers.delete.unavailableTitle');
      }
      return '404';
    },
    loadErrorMessage() {
      if (this.sellerLoadError === 403) {
        return this.$t('store-sellers.delete.forbidden');
      }
      if (this.sellerLoadError === 404) {
        return this.$t('store-sellers.delete.alreadyDeactivated');
      }
      return this.$t('store-sellers.delete.not-found');
    },
    sellerId() {
      return sellerIdFromRoute(this.$route);
    },
    listRoute() {
      return storeSellerListRoute(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions(['fetchSeller', 'deleteSeller']),
    loadSeller() {
      return this.fetchSeller(this.sellerId);
    },
    confirmDelete() {
      return this.deleteSeller(this.sellerId);
    },
    onDeleted() {
      this.$router.push(this.listRoute);
    },
  },
};
</script>
